var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponUsage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.6667,
    cy: 55,
    r: 54.5,
    fill: "white",
    stroke: "#D8E0E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4444 42H68.4444C68.8275 42 69.1949 42.1522 69.4658 42.4231C69.7367 42.694 69.8889 43.0614 69.8889 43.4444V66.5556C69.8889 66.9386 69.7367 67.306 69.4658 67.5769C69.1949 67.8478 68.8275 68 68.4444 68H42.4444C42.0614 68 41.694 67.8478 41.4231 67.5769C41.1522 67.306 41 66.9386 41 66.5556V43.4444C41 43.0614 41.1522 42.694 41.4231 42.4231C41.694 42.1522 42.0614 42 42.4444 42ZM45.3333 47.7778V50.6667H48.2222V47.7778H45.3333ZM45.3333 53.5556V56.4444H48.2222V53.5556H45.3333ZM45.3333 59.3333V62.2222H65.5556V59.3333H45.3333ZM51.1111 53.5556V56.4444H54V53.5556H51.1111ZM51.1111 47.7778V50.6667H54V47.7778H51.1111ZM56.8889 47.7778V50.6667H59.7778V47.7778H56.8889ZM62.6667 47.7778V50.6667H65.5556V47.7778H62.6667ZM56.8889 53.5556V56.4444H59.7778V53.5556H56.8889ZM62.6667 53.5556V56.4444H65.5556V53.5556H62.6667Z",
    fill: "#3C7AE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponUsage1);
export default __webpack_public_path__ + "static/media/coupon_usage_1.64b3b4d49684ca03829fe8b3acfff0b4.svg";
export { ForwardRef as ReactComponent };